enum transactionTypes {
    CREDIT = "credit",
    DEBIT = "debit",
    BAE = "bae",
    TOP_UP = "top_up",
    INITIAL = "initial"
}

export default transactionTypes